import { ChangeDetectionStrategy, Component, Input, signal, WritableSignal } from '@angular/core';
import { LnEmptySearchCardComponent } from '@components/cards/ln-empty-search-card/ln-empty-search-card.component';
import { MainProductCardComponent } from '@components/cards/main-product-card/main-product-card.component';
import { SpecialProductInterface } from '@interfaces/products/special_product_interface';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-special-products-search-result',
  imports: [LnEmptySearchCardComponent, MainProductCardComponent, TranslocoPipe],
  templateUrl: './special-products-search-result.component.html',
  styleUrl: './special-products-search-result.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialProductsSearchResultComponent {
  @Input({ required: true }) products: WritableSignal<SpecialProductInterface[] | null> = signal<
    SpecialProductInterface[] | null
  >(null);
}
